import _get from 'lodash-es/get';
import { call, put } from 'redux-saga/effects';
import {
  createProgramFailed,
  createProgramSuccess,
  reviewProgramFailed,
  reviewProgramSuccess,
  getAllProgramsFailed,
  getAllProgramsSuccess,
  getProgramDetailsFailed,
  getProgramDetailsSuccess,
  getProgramInfoFailed,
  getProgramInfoSuccess,
  getProgramStatusFailed,
  getProgramStatusSuccess,
  getTopProgramsFailed,
  getTopProgramsSuccess,
} from '../../actions/programs';
import {
  CREATE_PROGRAM_URL,
  GET_ALL_PROGRAMS,
  GET_PROGRAM_DETAILS,
  GET_PROGRAM_INFO,
  GET_TOP_PROGRAMS,
  TOGGLE_PROGRAM_STATUS,
  REVIEW_PROGRAM_URL,
} from '../../constants/urls';
import {
  CONFIRM_PROGRAM_DEACTIVATION,
  genericErrorMsg,
} from '../../pages/common/components/constants';
import zfetch, {
  METHOD_GET,
  METHOD_POST,
} from '../../pages/common/utils/zfetch';
import { openErrorToast, openSuccessToast } from '../../reducers/uiLogic';

const getAllPrograms = ({ workspaceId, flowType }) => {
  const options = {
    method: METHOD_GET,
    params: { workspace_id: workspaceId, flow_type: flowType },
  };
  return zfetch(GET_ALL_PROGRAMS, options);
};

export function* getAllProgramsSaga(action) {
  let programsData = {};

  try {
    const response = yield getAllPrograms(action.payload);
    const jsonResponse = yield response.json();
    const { data } = jsonResponse;
    programsData = data;
  } catch (error) {
    let err = error;
    if (error.response) {
      err = yield err.response;
    }
    yield put(getAllProgramsFailed(err));
    return;
  }

  yield put(getAllProgramsSuccess(programsData));
}

const getTopPrograms = (body = {}) => {
  const options = {
    method: METHOD_GET,
    body: JSON.stringify(body),
  };
  return zfetch(GET_TOP_PROGRAMS, options);
};

export function* getTopProgramsSaga(action) {
  let topPrograms = {};
  const body = {
    month: action.payload,
  };

  try {
    const response = yield getTopPrograms(body);
    const jsonResponse = yield response.json();
    const { data } = jsonResponse;
    topPrograms = data;
  } catch (error) {
    let err = error;
    if (error.response) {
      err = yield err.response;
    }
    yield put(openErrorToast());
    yield put(getTopProgramsFailed(err));
    return;
  }

  yield put(getTopProgramsSuccess(topPrograms));
}

const reviewProgram = ({ programBody = {} }) => {
  const options = {
    body: JSON.stringify(programBody),
    method: METHOD_POST,
  };
  return zfetch(REVIEW_PROGRAM_URL, options);
};

const getReviewProgram = program => {
  return reviewProgram(program).then(res => res.json());
};

export function* reviewProgramSaga(action) {
  let reviewProgramDetails = {};
  try {
    reviewProgramDetails = yield call(() => {
      return getReviewProgram(action.payload);
    });
  } catch (err) {
    yield put(openErrorToast());
    yield put(reviewProgramFailed(err));
    return;
  }
  const success = reviewProgramDetails?.status;
  if (success) {
    yield put(reviewProgramSuccess(reviewProgramDetails));
  } else {
    const title = _get(reviewProgramDetails, 'message.title', genericErrorMsg);
    yield put(openErrorToast());
    yield put(reviewProgramFailed(title));
  }
}

const createProgram = ({ programBody = {} }) => {
  const options = {
    body: JSON.stringify(programBody),
    method: METHOD_POST,
  };
  return zfetch(CREATE_PROGRAM_URL, options);
};

const getProgram = programBody => {
  return createProgram(programBody).then(res => res.json());
};

export function* createProgramSaga(action) {
  let newProgram = {};

  try {
    newProgram = yield call(() => {
      return getProgram(action.payload);
    });
    const { status: success } = newProgram;
    const title = _get(newProgram, 'message.title', genericErrorMsg);
    if (success) {
      yield put(createProgramSuccess(newProgram));
    } else {
      yield put(openErrorToast(title));
      yield put(createProgramFailed(title));
    }
  } catch (err) {
    yield put(openErrorToast());
    yield put(createProgramFailed(err));
  }

  // const {
  //   success,
  //   data: {
  //     program_id: programId = '',
  //     message: { title = genericErrorMsg, subtitle = '' },
  //   },
  // } = newProgram;

  // if (success) {
  // Get 2FA state
  // const twoFactorState = _get(newProgram, 'two_factor.state', 0);

  // if state is not 0 then do 2FA flow otherwiss follow old api flow
  // if (twoFactorState === 0) {
  //   yield put(
  //     createProgramSuccess({
  //       success,
  //       programId,
  //       title,
  //       subtitle,
  //     }),
  //   );
  //   yield put({ type: 'TWO_FACTOR_CLOSE' });
  // } else {
  //   // getting data
  //   const otpBoxCount = _get(newProgram, 'two_factor.length', 0);
  //   const email = _get(newProgram, 'two_factor.email', '');
  //   const message = _get(newProgram, 'two_factor.message', '');
  //   const newHash = _get(newProgram, 'two_factor.hash', '');
  //   const oldHash = _get(action.payload, 'hash', '');

  //   const load = {
  //     state: twoFactorState,
  //     length: otpBoxCount,
  //     hash: newHash === '' ? oldHash : newHash,
  //     message,
  //     email,
  //     actionType: 'CREATE_PROGRAM',
  //     payload: action.payload,
  //   };
  //       yield put(createProgramFailed());
  //       yield put({ type: 'TWO_FACTOR_OPEN', payload: load });
  //     // }
  //   } else {
  //     yield put(openErrorToast());
  //     yield put(createProgramFailed(title));
  //   }
  // }
}

const getProgramInfo = ({ programId, workspaceId }) => {
  const options = {
    method: METHOD_GET,
    params: {
      program_id: programId,
      workspace_id: workspaceId,
    },
  };
  return zfetch(GET_PROGRAM_INFO, options);
};

export function* getProgramInfoSaga(action) {
  let programInfo = {};

  try {
    const response = yield getProgramInfo(action.payload);
    const jsonResponse = yield response.json();
    const { data } = jsonResponse;
    programInfo = data;
  } catch (error) {
    let err = error;
    if (error.response) {
      err = yield err.response;
    }
    yield put(getProgramInfoFailed(err));
    return;
  }

  yield put(getProgramInfoSuccess(programInfo));
}

const getProgramDetails = id => {
  const options = {
    method: METHOD_POST,
    body: JSON.stringify({}),
  };
  return zfetch(`${GET_PROGRAM_DETAILS}/${id}`, options);
};

export function* getProgramDetailsSaga(action) {
  let programData = {};

  try {
    const response = yield getProgramDetails(action.payload);
    const jsonResponse = yield response.json();
    const { data } = jsonResponse;
    programData = data;
  } catch (error) {
    let err = error;
    if (error.response) {
      err = yield err.response;
    }
    yield put(getProgramDetailsFailed(err));
    return;
  }

  yield put(getProgramDetailsSuccess(programData));
}

const getProgramStatus = params => {
  const { id = '', activate = true } = params;

  const options = {
    method: METHOD_POST,
    body: JSON.stringify({
      activate,
    }),
  };
  return zfetch(`${TOGGLE_PROGRAM_STATUS}/${id}`, options);
};

export function* getProgramStatusSaga(action) {
  let programStatus = {};
  let successMessage = '';

  try {
    const response = yield getProgramStatus(action.payload);
    const jsonResponse = yield response.json();
    const {
      data: { message = {} },
    } = jsonResponse;
    successMessage = _get(message, 'title', CONFIRM_PROGRAM_DEACTIVATION.title);
    programStatus = 'Inactive';
  } catch (error) {
    let err = error;
    if (error.response) {
      err = yield err.response;
    }
    yield put(openErrorToast());
    yield put(getProgramStatusFailed(err));
    return;
  }

  yield put(openSuccessToast(successMessage));
  yield put(getProgramStatusSuccess(programStatus));
}
